exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#overlay[data-v-b407c932]{position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background-image:-webkit-gradient(linear,left top,right bottom,from(#1d76a5),to(#1d44a5));background-image:linear-gradient(to bottom right,#1d76a5,#1d44a5);color:#fff;text-align:center;font-size:35px;z-index:100000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b407c932","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/layouts/default.vue
// module id = cpKZ
// module chunks = 29